export interface PasswordRule {
  id: string;
  label: string;
  test: (pw: string) => boolean;
}

function hasSequentialRun(pw: string, runLen = 4): boolean {
  for (let i = 0; i <= pw.length - runLen; i++) {
    let asc = true;
    let desc = true;
    for (let j = 1; j < runLen; j++) {
      const diff = pw.charCodeAt(i + j) - pw.charCodeAt(i + j - 1);
      if (diff !== 1) asc = false;
      if (diff !== -1) desc = false;
    }
    if (asc || desc) return true;
  }
  return false;
}

export const PASSWORD_RULES: PasswordRule[] = [
  {
    id: "minLength",
    label: "At least 8 characters",
    test: pw => pw.length >= 8,
  },
  {
    id: "uppercase",
    label: "At least 1 uppercase letter (A–Z)",
    test: pw => /[A-Z]/.test(pw),
  },
  {
    id: "lowercase",
    label: "At least 1 lowercase letter (a–z)",
    test: pw => /[a-z]/.test(pw),
  },
  {
    id: "symbol",
    label: "At least 1 symbol  (e.g. !@#$%^&*)",
    test: pw => /[^A-Za-z0-9]/.test(pw),
  },
  {
    id: "noSequential",
    label: "No 4+ sequential characters (e.g. 1234, abcd)",
    test: pw => !hasSequentialRun(pw, 4),
  },
];

export function validatePassword(pw: string): { valid: boolean; failed: string[] } {
  const failed = PASSWORD_RULES.filter(r => !r.test(pw)).map(r => r.id);
  return { valid: failed.length === 0, failed };
}
